{
  "common": {
    "cancel": "Отмена",
    "save": "Сохранить",
    "delete": "Удалить",
    "done": "Готово",
    "edit": "Изменить",
    "search": "Поиск",
    "loading": "Загрузка…",
    "yes": "Да",
    "no": "Нет",
    "settings": "Настройки",
    "back": "Назад",
    "close": "Закрыть",
    "open": "Открыть",
    "copy": "Копировать",
    "restore": "Восстановить",
    "untitled": "Без названия",
    "create": "Создать",
    "revoke": "Отозвать",
    "never": "Никогда",
    "tryAgain": "Повторить",
    "reload": "Перезагрузить",
    "update": "Обновить",
    "insert": "Вставить",
    "loadingShort": "Загрузка",
    "unknown": "Неизвестно",
    "sampleSentence": "Съешь же ещё этих булочек"
  },
  "sidebar": {
    "views": "Подборки",
    "tags": "Теги",
    "edit": "Изменить",
    "done": "Готово",
    "account": "Аккаунт",
    "newNote": "Новая заметка",
    "editTag": "Изменить тег",
    "tagOptions": "Параметры тега",
    "reorder": "Переместить {{label}}",
    "showView": "Показать {{label}}",
    "hideView": "Скрыть {{label}}",
    "editViews": "Настроить подборки",
    "doneEditingViews": "Готово",
    "samplePeep": "Что такое Caliu…",
    "sampleQuiet": "Тихое место, где живут и дышат ваши мысли."
  },
  "views": {
    "all": "Все заметки",
    "today": "Сегодня",
    "todo": "Задачи",
    "pinned": "Закреплённые",
    "untagged": "Без тегов",
    "thisWeek": "На этой неделе",
    "shared": "Открыты мной",
    "sharedWithMe": "Открыты мне",
    "attachments": "Вложения",
    "trash": "Корзина",
    "archive": "Архивированные"
  },
  "noteList": {
    "empty": "Пока нет заметок",
    "emptySubtitle": "Создайте первую заметку, чтобы начать.",
    "untitled": "Без названия",
    "selectNote": "Выберите заметку",
    "selectNoteHint": "Выберите заметку из списка или создайте новую.",
    "selectRestoreOrDelete": "Выберите заметку, чтобы восстановить или удалить навсегда",
    "selectSharedToView": "Выберите заметку с общим доступом, чтобы открыть её",
    "searchPlaceholder": "Поиск по заметкам…",
    "selectNotes": "Выбрать заметки",
    "openSidebar": "Открыть боковую панель",
    "cancelSelection": "Отменить выбор",
    "clearSelection": "Снять выделение",
    "emptyTrash": "Очистить корзину",
    "newNote": "Новая заметка",
    "noteCount_one": "{{count}} заметка",
    "noteCount_few": "{{count}} заметки",
    "noteCount_many": "{{count}} заметок",
    "noteCount_other": "{{count}} заметки",
    "sortBy": "Сортировать по",
    "preview": "Предпросмотр",
    "modificationDate": "Дата изменения",
    "creationDate": "Дата создания",
    "title": "Название",
    "manual": "Вручную",
    "newestOnTop": "Сначала новые",
    "small": "Мелкий",
    "medium": "Средний",
    "large": "Крупный",
    "empty_pinned": "Пока ничего не закреплено",
    "empty_pinned_subtitle": "Закрепите заметку, чтобы быстро находить её здесь.",
    "empty_today": "Сегодня ничего не менялось",
    "empty_today_subtitle": "Заметки, которые вы откроете сегодня, появятся здесь.",
    "empty_todo": "Пока нет задач",
    "empty_todo_subtitle": "Заметки с незавершёнными задачами появятся здесь.",
    "empty_untagged": "У всего есть теги",
    "empty_untagged_subtitle": "Заметки без тегов появятся здесь.",
    "empty_thisWeek": "На этой неделе ничего нет",
    "empty_thisWeek_subtitle": "Заметки, изменённые за последние 7 дней, появятся здесь.",
    "empty_shared": "Нет заметок с общим доступом",
    "empty_shared_subtitle": "Заметки, которыми вы поделитесь, появятся здесь.",
    "empty_attachments": "Пока нет вложений",
    "empty_attachments_subtitle": "Заметки с изображениями или файлами появятся здесь.",
    "justNow": "Только что",
    "minutesAgo": "{{count}} мин назад",
    "today": "Сегодня",
    "yesterday": "Вчера",
    "deletedOn": "Удалено {{date}}",
    "newNoteShortcut": "Новая заметка ({{shortcut}})",
    "noContent": "Нет содержимого",
    "selectUnarchiveOrDelete": "Выберите заметку, чтобы разархивировать или удалить её",
    "view": "Вид",
    "density": "Плотность",
    "exportAll": "Экспортировать все"
  },
  "editor": {
    "attachmentTooLarge": "Этот файл слишком большой для вложения. Лимит: 100 МБ.",
    "placeholder": "Начните писать…",
    "noMatchingCommands": "Нет подходящих команд",
    "newNote": "новая заметка",
    "noResults": "Ничего не найдено",
    "foldSection": "Свернуть раздел",
    "unfoldSection": "Развернуть раздел",
    "dragSection": "Переместить раздел",
    "presenceLabel": "Также здесь: {{names}}"
  },
  "noteActions": {
    "pin": "Закрепить",
    "unpin": "Открепить",
    "pinToTop": "Закрепить сверху",
    "makeReadOnly": "Сделать только для чтения",
    "makeEditable": "Сделать редактируемой",
    "readOnlyNote": "Заметка только для чтения",
    "shareNote": "Поделиться заметкой",
    "share": "Поделиться",
    "publiclyShared": "Открыт общий доступ",
    "privateNote": "Личная заметка",
    "linkCreated": "Ссылка создана",
    "linkCreatedAndCopied": "Ссылка создана и скопирована",
    "linkRevoked": "Доступ по ссылке закрыт",
    "failedToCreateShareLink": "Не удалось создать ссылку",
    "failedToRevokeShareLink": "Не удалось закрыть доступ по ссылке",
    "thisNoteIsPrivate": "Это личная заметка.",
    "createPublicLink": "Создать общедоступную ссылку",
    "creatingLink": "Создание ссылки…",
    "revokeLink": "Закрыть доступ",
    "revokingLink": "Закрытие доступа…",
    "copyLink": "Копировать ссылку",
    "copyNoteId": "Скопировать ID заметки",
    "noteIdCopied": "ID заметки скопирован",
    "exportAs": "Экспортировать как",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Простой текст",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Не удалось экспортировать",
    "viewHistory": "Посмотреть историю",
    "duplicate": "Дублировать",
    "duplicateFailed": "Не удалось дублировать заметку",
    "select": "Выбрать",
    "delete": "Удалить",
    "moveToTrash": "В корзину",
    "archive": "Архивировать",
    "unarchive": "Разархивировать",
    "tags": "Теги",
    "addTag": "Добавить тег",
    "noTagsYet": "Тегов пока нет",
    "addTagFailed": "Не удалось добавить тег",
    "removeTagFailed": "Не удалось удалить тег"
  },
  "userMenu": {
    "theme": "Тема",
    "typography": "Типографика",
    "language": "Язык",
    "apiKeys": "API-ключи",
    "devices": "Устройства",
    "connectedApps": "Подключённые приложения",
    "help": "Помощь",
    "logOut": "Выйти",
    "defaultUserName": "Пользователь Caliu",
    "editName": "Изменить имя",
    "nameLabel": "Имя",
    "namePlaceholder": "Ваше имя",
    "upgradeToPro": "Перейти на Caliu Pro",
    "replayOnboarding": "Пройти знакомство заново",
    "logOutTitle": "Выйти?",
    "logOutBody": "Ваши заметки останутся на этом устройстве, их можно будет читать и редактировать. Войдите снова, чтобы включить синхронизацию.",
    "logOutPending_one": "{{count}} изменение ещё не синхронизировано. Оно останется на этом устройстве до следующего входа.",
    "logOutPending_few": "{{count}} изменения ещё не синхронизированы. Они останутся на этом устройстве до следующего входа.",
    "logOutPending_many": "{{count}} изменений ещё не синхронизировано. Они останутся на этом устройстве до следующего входа.",
    "logOutPending_other": "{{count}} изменения ещё не синхронизированы. Они останутся на этом устройстве до следующего входа.",
    "logOutKeep": "Выйти",
    "logOutAndRemove": "Выйти и удалить заметки"
  },
  "help": {
    "title": "Справочный центр",
    "searchPlaceholder": "Поиск по справке",
    "noResults": "По вашему запросу ничего не найдено.",
    "offline": "Справка недоступна офлайн. Она загрузится при следующем подключении."
  },
  "fonts": {
    "uiFont": "Шрифт интерфейса",
    "body": "Текст",
    "headings": "Заголовки",
    "code": "Код",
    "sans": "Без засечек",
    "serif": "С засечками",
    "mono": "Моноширинный",
    "editor": "Редактор",
    "ui": "Интерфейс",
    "reset": "Сбросить к стандартным"
  },
  "themes": {
    "light": "Светлая",
    "dark": "Тёмная",
    "system": "Системная"
  },
  "languages": {
    "systemHint": "Определён по настройкам устройства",
    "names": {
      "en": "Английский",
      "es": "Испанский",
      "ca": "Каталанский",
      "fr": "Французский",
      "de": "Немецкий",
      "it": "Итальянский",
      "pt": "Португальский",
      "nl": "Нидерландский",
      "ja": "Японский",
      "zh-CN": "Китайский (упрощённый)",
      "ko": "Корейский",
      "zh-TW": "Китайский (традиционный)",
      "ru": "Русский"
    }
  },
  "bulkActions": {
    "pinSelected": "Закрепить выбранные",
    "unpinSelected": "Открепить выбранные",
    "pin": "Закрепить",
    "addTag": "Добавить тег",
    "filterTags": "Фильтр тегов…",
    "noTagsFound": "Теги не найдены",
    "exportSelected": "Экспортировать выбранные",
    "restoreSelected": "Восстановить выбранные",
    "deletePermanently": "Удалить навсегда",
    "moveToTrash": "В корзину",
    "archiveSelected": "Архивировать выбранные",
    "unarchiveSelected": "Разархивировать выбранные",
    "exportingTitle": "Экспорт заметок",
    "exportingBody": "Это может занять некоторое время. Не закрывайте эту вкладку до завершения.",
    "exportingProgress": "{{done}} из {{total}}"
  },
  "commandPalette": {
    "placeholder": "Поиск заметок, тегов, команд…",
    "noResults": "Ничего не найдено по запросу «{{query}}»",
    "currentNote": "Текущая заметка",
    "navigation": "Навигация",
    "notes": "Заметки",
    "tags": "Теги",
    "newNote": "Новая заметка",
    "allNotes": "Все заметки",
    "todaysNotes": "Заметки за сегодня",
    "todo": "Задачи",
    "pinnedNotes": "Закреплённые заметки",
    "trash": "Корзина",
    "importNotes": "Импорт заметок",
    "changeTheme": "Сменить тему",
    "keyboardShortcuts": "Сочетания клавиш",
    "pinNote": "Закрепить заметку",
    "unpinNote": "Открепить заметку",
    "restoreNote": "Восстановить заметку",
    "copyShareLink": "Копировать ссылку",
    "makePrivate": "Сделать личной",
    "toggleFullscreen": "Полноэкранный режим",
    "noteInfo": "О заметке",
    "moveToTrash": "В корзину",
    "archiveNote": "Архивировать заметку",
    "unarchiveNote": "Разархивировать заметку",
    "archive": "Архивированные"
  },
  "noteHistory": {
    "title": "История заметки",
    "requiresConnection": "Для истории заметки нужно подключение.",
    "reconnect": "Подключитесь к интернету и попробуйте снова.",
    "noHistory": "Для этой заметки ещё нет истории.",
    "windowMerged": "Изменения в пределах 5 минут объединяются в одну запись.",
    "selectVersion": "Выберите версию для просмотра",
    "encrypted": "Зашифрованный снимок",
    "encryptedHint": "Эта версия сохранена со сквозным шифрованием. Откройте заметку, чтобы увидеть текущее содержимое.",
    "restoreVersion": "Восстановить эту версию?",
    "restoreVersionHint": "Текущее содержимое заметки будет заменено версией от {{date}}.",
    "current": "Текущая",
    "created": "Создана",
    "trashed": "В корзине",
    "restored": "Восстановлена",
    "edited": "Изменена"
  },
  "apiKeys": {
    "title": "API-ключи",
    "empty": "Пока нет API-ключей.",
    "emptyHint": "Создайте ключ, чтобы начать пользоваться API.",
    "created": "Создан {{date}}",
    "lastUsed": "Использован: {{date}}",
    "revokeKey": "Отозвать ключ",
    "viewApiDocs": "Документация API",
    "newApiKey": "Новый API-ключ",
    "apiKeyCreated": "API-ключ создан",
    "createApiKey": "Создать API-ключ",
    "copyHint": "Скопируйте ключ сейчас. Позже его нельзя будет посмотреть.",
    "copyToClipboard": "Копировать в буфер обмена",
    "keyName": "Название ключа",
    "keyNamePlaceholder": "например, My Script, Zapier Integration",
    "createKey": "Создать ключ",
    "revokeKeyTitle": "Отозвать API-ключ",
    "revokeKeyHint": "Этот API-ключ будет отозван навсегда. Все приложения, использующие его, сразу потеряют доступ.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Подключённые приложения",
    "empty": "Пока нет подключённых приложений.",
    "emptyHint": "Подключите Claude, ChatGPT или другого ИИ-ассистента, чтобы пользоваться заметками прямо из чата. Как это сделать, рассказано в разделе «Caliu и ИИ» в «Помощи».",
    "connected": "Подключено {{date}}",
    "lastUsed": "Использовано: {{date}}",
    "revoke": "Отозвать",
    "revokeTitle": "Отозвать подключение",
    "revokeHint": "Доступ <strong>{{name}}</strong> к вашему аккаунту Caliu будет отозван, а использованные учётные данные удалены. Приложение сразу потеряет доступ.",
    "thisApp": "это приложение",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Текст",
    "metadata": "Метаданные",
    "words": "Слова",
    "characters": "Символы",
    "paragraphs": "Абзацы",
    "readTime": "Время чтения",
    "minutes": "{{count}} мин",
    "tags": "Теги",
    "outgoingLinks": "Исходящие ссылки",
    "backlinks": "Обратные ссылки",
    "created": "Создана",
    "modified": "Изменена",
    "noteStatistics": "Статистика заметки",
    "identifier": "Идентификатор"
  },
  "inspector": {
    "tabInfo": "Инфо",
    "tabOutline": "Структура",
    "tabHistory": "История",
    "dates": "Даты",
    "noHeadings": "В этой заметке нет заголовков",
    "noBacklinks": "Ни одна заметка не ссылается сюда",
    "noOutgoing": "Эта заметка никуда не ссылается",
    "noAttachments": "В этой заметке нет вложений",
    "historyOffline": "Для истории версий нужно подключение к интернету",
    "historyLoadMore": "Загрузить ещё"
  },
  "devices": {
    "title": "Устройства",
    "offline": "Вы офлайн.",
    "offlineHint": "Подключитесь к интернету, чтобы увидеть свои устройства.",
    "noSessions": "Активных сеансов не найдено.",
    "thisDevice": "Это устройство",
    "lastUsed": "Использовано: {{date}}",
    "created": "Создано: {{date}}",
    "signOutCurrent": "Выйти на этом устройстве",
    "signOut": "Выйти",
    "confirmCurrentTitle": "Выйти на этом устройстве?",
    "confirmRevokeTitle": "Отозвать устройство?",
    "confirmCurrentBody": "Вы выйдете из Caliu в этом браузере, а заметки будут удалены с этого устройства. Войдите снова в любой момент, и они вернутся из вашего аккаунта.",
    "confirmRevokeBody": "Устройство сразу выйдет из аккаунта. Все несинхронизированные изменения на нём останутся там до следующего входа.",
    "revoke": "Отозвать"
  },
  "errorScreen": {
    "title": "Что-то пошло не так",
    "defaultMessage": "Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу."
  },
  "importModal": {
    "title": "Импорт заметок",
    "dropToImport": "Отпустите, чтобы импортировать",
    "dropOrClick": "Перетащите файлы или нажмите, чтобы выбрать",
    "removeFile": "Удалить файл",
    "keepNote": "Для Google Keep экспортируйте архив Takeout (ZIP) и загрузите его напрямую.",
    "importedCount_one": "Импортирована <strong>{{count}}</strong> заметка",
    "importedCount_few": "Импортировано <strong>{{count}}</strong> заметки",
    "importedCount_many": "Импортировано <strong>{{count}}</strong> заметок",
    "importedCount_other": "Импортировано <strong>{{count}}</strong> заметки",
    "fromSource": " из {{source}}",
    "importing": "Импорт…",
    "importN": "Импортировать {{count}} файлов",
    "importBtn": "Импортировать"
  },
  "share": {
    "shareNote": "Поделиться заметкой",
    "publiclySharedAria": "Заметка с открытым общим доступом",
    "copyLink": "Копировать ссылку",
    "revokingLink": "Закрытие доступа…",
    "revokeLink": "Закрыть доступ",
    "creatingLink": "Создание ссылки…",
    "createPublicLink": "Создать общедоступную ссылку",
    "shareThisNotePublicly": "Открыть общий доступ к этой заметке",
    "thisNoteIsPrivate": "Это личная заметка.",
    "publiclyShared": "Открыт общий доступ",
    "privateNote": "Личная заметка"
  },
  "shortcuts": {
    "searchPlaceholder": "Поиск сочетаний…",
    "pressNew": "Нажмите новое сочетание…",
    "resetToDefault": "Сбросить по умолчанию",
    "noMatches": "Нет сочетаний по запросу «<strong>{{query}}</strong>»",
    "navigate": "перемещение",
    "edit": "изменение",
    "closeAction": "закрытие",
    "resetAll": "Сбросить все"
  },
  "tagEditor": {
    "icon": "Значок",
    "color": "Цвет",
    "searchIcons": "Поиск значков",
    "noIcons": "Нет подходящих значков",
    "categories": {
      "essentials": "Основное",
      "work": "Работа и техника",
      "ideas": "Идеи и творчество",
      "life": "Люди и дом",
      "travel": "Путешествия и природа",
      "fun": "Еда, здоровье и досуг"
    }
  },
  "tagActions": {
    "pin": "Закрепить тег",
    "unpin": "Открепить тег",
    "rename": "Переименовать…",
    "renameTitle": "Переименовать тег",
    "renameConfirm": "Переименовать",
    "renameHint": "Тег обновится во всех заметках, где он используется, включая архив и корзину.",
    "renamed": "Тег переименован",
    "nameInUse": "Это имя уже используется",
    "invalidName": "Имена тегов могут содержать только буквы, цифры, пробелы, дефисы и подчёркивания",
    "pinFailed": "Не удалось обновить тег",
    "renameFailed": "Не удалось переименовать тег",
    "editAppearance": "Изменить оформление"
  },
  "auth": {
    "appName": "Caliu",
    "or": "или",
    "email": "Электронная почта",
    "emailPlaceholder": "you@example.com",
    "password": "Пароль",
    "passwordPlaceholder": "Пароль",
    "name": "Имя",
    "namePlaceholder": "Ваше имя",
    "confirmPassword": "Подтвердите пароль",
    "newPassword": "Новый пароль",
    "confirmNewPassword": "Подтвердите новый пароль",
    "signInSubtitle": "Войдите в свой аккаунт",
    "createAccountSubtitle": "Создайте аккаунт",
    "forgotPassword": "Забыли пароль?",
    "signingIn": "Вход…",
    "signIn": "Войти",
    "noAccount": "Нет аккаунта?",
    "signUp": "Зарегистрироваться",
    "haveAccount": "Уже есть аккаунт?",
    "creatingAccount": "Создание аккаунта…",
    "createAccount": "Создать аккаунт",
    "googleSignUpAria": "Зарегистрироваться через Google",
    "signupClosedTitle": "Регистрация сейчас закрыта",
    "signupClosedBody": "Caliu в закрытой бете. Запишитесь в список ожидания на caliuapp.com, чтобы получить ранний доступ.",
    "joinWaitlist": "Записаться в список ожидания",
    "forgotTitle": "Сброс пароля",
    "forgotSubtitle": "Введите электронную почту, и мы отправим ссылку для сброса.",
    "sendResetLink": "Отправить ссылку для сброса",
    "sending": "Отправка…",
    "checkYourEmail": "Проверьте почту",
    "resetLinkSentPrefix": "Если у ",
    "resetLinkSentSuffix": " есть аккаунт, мы отправили ссылку для сброса пароля. Она действует 1 час.",
    "backToSignIn": "Назад ко входу",
    "verifySentPrefix": "Мы отправили ссылку для подтверждения на ",
    "verifySentSuffix": ". Нажмите её, чтобы активировать аккаунт.",
    "linkExpires10m": "Ссылка действует 10 минут.",
    "resending": "Повторная отправка…",
    "resendEmail": "Отправить письмо снова",
    "wrongEmail": "Не та почта?",
    "goBack": "Назад",
    "invalidResetLinkTitle": "Недействительная ссылка для сброса",
    "invalidResetLinkBody": "Эта ссылка недействительна или устарела.",
    "requestNewLink": "Запросить новую ссылку",
    "setNewPasswordTitle": "Задать новый пароль",
    "setNewPasswordHint": "Выберите надёжный пароль.",
    "updatingPassword": "Обновление…",
    "updatePassword": "Обновить пароль",
    "localNotesTitle": "На этом устройстве есть заметки",
    "localNotesBody_one": "До входа вы написали здесь {{count}} заметку. Что с ней сделать?",
    "localNotesBody_few": "До входа вы написали здесь {{count}} заметки. Что с ними сделать?",
    "localNotesBody_many": "До входа вы написали здесь {{count}} заметок. Что с ними сделать?",
    "localNotesBody_other": "До входа вы написали здесь {{count}} заметки. Что с ними сделать?",
    "localNotesDelete": "Удалить их",
    "localNotesMerge": "Добавить в мой аккаунт",
    "backToMyNotes": "Назад к моим заметкам",
    "errorGoogleAuthFailed": "Не удалось войти через Google. Повторите попытку.",
    "errorInvalidToken": "Недействительная ссылка для подтверждения. Зарегистрируйтесь снова.",
    "errorEmailTaken": "Этот адрес уже используется. Войдите в аккаунт.",
    "signInInstead": "Войти в тот аккаунт",
    "errorIdentityTaken": "Этот способ входа уже принадлежит другому аккаунту Caliu. Войдите в него.",
    "parkedNotesTitle": "Заметки другого аккаунта",
    "parkedNotesBody_one": "Войдите в {{email}}, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит единственную заметку отсюда, включая всё написанное после.",
    "parkedNotesBody_few": "Войдите в {{email}}, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит все {{count}} заметки отсюда, включая всё написанное после.",
    "parkedNotesBody_many": "Войдите в {{email}}, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит все {{count}} заметок отсюда, включая всё написанное после.",
    "parkedNotesBody_other": "Войдите в {{email}}, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит все {{count}} заметки отсюда, включая всё написанное после.",
    "parkedNotesBodyNoEmail_one": "Войдите в аккаунт, из которого вы вышли, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит единственную заметку отсюда, включая всё написанное после.",
    "parkedNotesBodyNoEmail_few": "Войдите в аккаунт, из которого вы вышли, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит все {{count}} заметки отсюда, включая всё написанное после.",
    "parkedNotesBodyNoEmail_many": "Войдите в аккаунт, из которого вы вышли, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит все {{count}} заметок отсюда, включая всё написанное после.",
    "parkedNotesBodyNoEmail_other": "Войдите в аккаунт, из которого вы вышли, чтобы сохранить заметки этого аккаунта на устройстве. Другой аккаунт удалит все {{count}} заметки отсюда, включая всё написанное после.",
    "parkedNotesContinue": "Продолжить"
  },
  "connectors": {
    "wantsAccess": "запрашивает доступ к Caliu",
    "couldntLoad": "Не удалось загрузить этот запрос",
    "authorize": "Авторизовать",
    "keepHappeningHint": "Если это повторяется, удалите коннектор из вашего MCP-клиента и добавьте его снова.",
    "backToCaliu": "Назад в Caliu",
    "askingPermissionPrefix": "запрашивает разрешение читать и изменять ваши заметки и теги через MCP-сервер Caliu.",
    "signedInAs": "Вход выполнен как {{name}}.",
    "permissions": "Разрешения",
    "deny": "Отклонить",
    "allow": "Разрешить"
  },
  "editorTypography": {
    "fontSize": "Размер шрифта",
    "lineHeight": "Межстрочный интервал",
    "paragraphSpacing": "Интервал между абзацами"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "Отменить",
    "redo": "Повторить",
    "taskList": "Список задач",
    "bulletList": "Маркированный список",
    "orderedList": "Нумерованный список",
    "blockQuote": "Цитата",
    "separator": "Разделитель",
    "insertTag": "Вставить тег",
    "highlight": "Выделение",
    "math": "Формула",
    "removeHighlight": "Убрать выделение",
    "inlineCode": "Встроенный код",
    "codeBlock": "Блок кода",
    "insertTable": "Вставить таблицу",
    "insertImage": "Вставить изображение",
    "hideStyleBar": "Скрыть панель стилей",
    "attachFile": "Прикрепить файл",
    "photoLibrary": "Медиатека",
    "camera": "Камера",
    "fromFile": "Из файла"
  },
  "imageDialog": {
    "title": "Вставить изображение",
    "tabUpload": "Файл",
    "tabUrl": "URL",
    "urlLabel": "URL изображения",
    "urlPlaceholder": "https://example.com/image.jpg",
    "altLabel": "Альтернативный текст",
    "altPlaceholder": "Опишите изображение…",
    "previewAlt": "превью",
    "changeImage": "Сменить изображение",
    "dropToInsert": "Отпустите, чтобы вставить",
    "dropOrClick": "Перетащите изображение или нажмите, чтобы выбрать",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Вставить изображение"
  },
  "linkDialog": {
    "editTitle": "Изменить ссылку",
    "insertTitle": "Вставить ссылку",
    "textLabel": "Текст",
    "textPlaceholder": "Текст ссылки",
    "urlPlaceholder": "https://example.com",
    "removeLink": "Удалить ссылку",
    "openLink": "Открыть ссылку",
    "editLink": "Изменить ссылку"
  },
  "noteEditor": {
    "notFound": "Заметка не найдена.",
    "inTrashBanner": "Эта заметка в корзине. Восстановите её, чтобы редактировать.",
    "restore": "Восстановить",
    "noContent": "В этой заметке нет содержимого."
  },
  "noteHeader": {
    "noteInfo": "О заметке"
  },
  "table": {
    "deleteRow": "Удалить строку",
    "deleteTable": "Удалить таблицу",
    "addRow": "Добавить строку",
    "addRowAbove": "Добавить строку выше",
    "addColumn": "Добавить столбец",
    "addColumnBefore": "Добавить столбец перед",
    "moveRowUp": "Переместить строку вверх",
    "moveRowDown": "Переместить строку вниз",
    "moveColumnLeft": "Переместить столбец влево",
    "moveColumnRight": "Переместить столбец вправо",
    "deleteColumn": "Удалить столбец",
    "actions": "Действия с таблицей"
  },
  "syncIndicator": {
    "synced": "Синхронизировано",
    "pending_one": "{{count}} ожидает синхронизации",
    "pending_few": "{{count}} ожидают синхронизации",
    "pending_many": "{{count}} ожидают синхронизации",
    "pending_other": "{{count}} ожидает синхронизации",
    "offline": "Не в сети",
    "offlinePending_one": "Не в сети · {{count}} в очереди",
    "offlinePending_few": "Не в сети · {{count}} в очереди",
    "offlinePending_many": "Не в сети · {{count}} в очереди",
    "offlinePending_other": "Не в сети · {{count}} в очереди",
    "syncing": "Синхронизация...",
    "conflict_one": "{{count}} конфликт",
    "conflict_few": "{{count}} конфликта",
    "conflict_many": "{{count}} конфликтов",
    "conflict_other": "{{count}} конфликта",
    "error": "Ошибка синхронизации",
    "syncedTooltip": "Все изменения сохранены",
    "pendingTooltip_one": "{{count}} изменение ожидает синхронизации",
    "pendingTooltip_few": "{{count}} изменения ожидают синхронизации",
    "pendingTooltip_many": "{{count}} изменений ожидают синхронизации",
    "pendingTooltip_other": "{{count}} изменения ожидает синхронизации",
    "offlineTooltip": "Не в сети: изменения синхронизируются после переподключения",
    "offlinePendingTooltip_one": "Не в сети: {{count}} изменение синхронизируется после переподключения",
    "offlinePendingTooltip_few": "Не в сети: {{count}} изменения синхронизируются после переподключения",
    "offlinePendingTooltip_many": "Не в сети: {{count}} изменений синхронизируются после переподключения",
    "offlinePendingTooltip_other": "Не в сети: {{count}} изменения синхронизируется после переподключения",
    "syncingTooltip": "Синхронизация...",
    "syncingPendingTooltip_one": "Синхронизация {{count}} изменения...",
    "syncingPendingTooltip_few": "Синхронизация {{count}} изменений...",
    "syncingPendingTooltip_many": "Синхронизация {{count}} изменений...",
    "syncingPendingTooltip_other": "Синхронизация {{count}} изменения...",
    "conflictTooltip_one": "{{count}} заметка содержит конфликтующие изменения. Нажмите, чтобы разрешить.",
    "conflictTooltip_few": "{{count}} заметки содержат конфликтующие изменения. Нажмите, чтобы разрешить.",
    "conflictTooltip_many": "{{count}} заметок содержат конфликтующие изменения. Нажмите, чтобы разрешить.",
    "conflictTooltip_other": "{{count}} заметки содержит конфликтующие изменения. Нажмите, чтобы разрешить.",
    "errorTooltip": "Не удалось синхронизировать. Повтор произойдёт автоматически.",
    "conflictsTitle": "Разрешить конфликты",
    "local": "На этом устройстве",
    "localTooltip": "Только на этом устройстве. Войдите, чтобы синхронизировать."
  },
  "image": {
    "download": "Скачать изображение",
    "replace": "Заменить изображение",
    "remove": "Удалить изображение"
  },
  "sharePage": {
    "goToCaliu": "Перейти в Caliu",
    "noteNotFoundTitle": "Заметка не найдена",
    "somethingWentWrong": "Что-то пошло не так",
    "lastUpdated": "Последнее изменение: {{date}}",
    "tagline": "Приложение для заметок тех, кто думает",
    "subtagline": "Пишите в Markdown. Синхронизируйте везде. Думайте ясно.",
    "startWriting": "Начать писать",
    "signIn": "Войти",
    "openInCaliu": "Открыть в Caliu",
    "adding": "Добавление…",
    "addToSharedList": "Добавить в мой список общих заметок",
    "notFoundSubtitle": "Возможно, эта ссылка устарела или доступ по ней закрыт.",
    "errorSubtitle": "Не удалось загрузить заметку. Попробуйте снова."
  },
  "sharedView": {
    "loading": "Загрузка общей заметки…",
    "sharedWithYou": "Поделились с вами",
    "viewRaw": "Показать исходный Markdown",
    "viewRendered": "Показать отформатированную заметку",
    "copyMarkdown": "Скопировать Markdown",
    "markdownCopied": "Markdown скопирован",
    "copyFailed": "Не удалось скопировать",
    "notLoadedYet": "Эта заметка ещё не загружена",
    "linkCopied": "Ссылка скопирована",
    "actions": "Действия с заметкой"
  },
  "sharedWithMe": {
    "title": "Открыты мне",
    "removeFromList": "Удалить из списка",
    "empty": "Пока нет общих заметок",
    "emptyHint": "Откройте ссылку Caliu от друга, чтобы добавить заметку сюда. Общие заметки синхронизируются между вашими устройствами."
  },
  "trashView": {
    "empty": "Корзина пуста",
    "emptyHint": "Удалённые заметки появятся здесь",
    "retention": "Заметки в корзине удаляются навсегда через 30 дней",
    "trash": "Корзина"
  },
  "fileAttachment": {
    "download": "Скачать файл",
    "remove": "Удалить файл"
  },
  "archiveView": {
    "archive": "Архивированные",
    "empty": "Архив пуст",
    "emptyHint": "Архивированные заметки появятся здесь",
    "archivedOn": "Архивировано {{date}}"
  },
  "pro": {
    "subtitle": "Caliu без ограничений.",
    "features": [
      "Безлимитные заметки",
      "История версий заметок",
      "Экспорт в PDF, HTML, RTF, ePub + массовый",
      "Все темы, шрифты и иконки приложения",
      "Поддерживает развитие Caliu"
    ],
    "perMonth": "{{price}} в месяц",
    "perWeek": "{{price}} в неделю",
    "oneTime": "{{price}} разовый платёж",
    "perYear": "{{price}} в год",
    "or": "или",
    "signInToSubscribe": "Войдите, чтобы оформить подписку",
    "accountRequired": "Caliu Pro привязан к вашему аккаунту, поэтому открывается на всех устройствах.",
    "plansUnavailable": "Не удалось загрузить тарифы. Проверьте подключение и попробуйте снова.",
    "yearly": "Ежегодно",
    "monthly": "Ежемесячно",
    "continue": "Продолжить",
    "bestValue": "Выгоднее всего",
    "autoRenew": "{{amount}}. Автопродление до отмены. Отменить можно в любой момент.",
    "freeTrial": "Бесплатно {{count}} дней",
    "billedSubtitle": "{{count}} дней бесплатно, затем {{amount}}. Отменить можно в любой момент.",
    "startTrial": "Начать бесплатный период",
    "upgradeSubtitle": "История версий, все темы и шрифты, экспорт и многое другое.",
    "upgradeNow": "Обновить сейчас",
    "thanks": "Спасибо, что поддерживаете Caliu!",
    "renewsOn": "Продлится {{date}}",
    "endsOn": "Закончится {{date}}",
    "lifetime": "Пожизненный доступ",
    "lifetimePlan": "Навсегда",
    "oneTimeNoRenewal": "Разовый платёж",
    "launchPrice": "Стартовая цена. Позже она вырастет до {{price}}.",
    "buy": "Купить",
    "oneTimeDisclosure": "{{amount}}. Разовый платёж, без продления.",
    "thanksMessage": "Ваша поддержка сохраняет Caliu независимым и приватным.",
    "manageSubscription": "Управление подпиской",
    "contactUs": "Вопросы? Напишите нам",
    "grandfatheredNote": "Как первый сторонник, вы получаете Caliu Pro навсегда. Ничего не нужно продлевать.",
    "webFootnote": "Экспорт в PDF пока недоступен в веб-версии.",
    "active": "Активна"
  },
  "find": {
    "placeholder": "Поиск в заметке",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Нет результатов",
    "next": "Следующее совпадение",
    "previous": "Предыдущее совпадение",
    "close": "Закрыть"
  },
  "conflicts": {
    "description": "Эта заметка была изменена на другом устройстве. Оставьте одну версию.",
    "yours": "Ваша версия",
    "theirs": "Другая версия",
    "step": "{{current}} из {{total}}",
    "keepYours": "Оставить вашу",
    "keepTheirs": "Оставить другую",
    "serverError": "Не удалось загрузить другую версию.",
    "done": "Все конфликты разрешены.",
    "previous": "Предыдущий конфликт",
    "next": "Следующий конфликт",
    "copyOf": "Копия: {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Добро пожаловать в Caliu",
    "welcomeSubtitle": "Тихое место, где ваши мысли живут и дышат.",
    "getStarted": "Начать",
    "magicTitle": "Смотрите, как слова обретают форму",
    "magicSubtitle": "Вы пишете обычный текст. Caliu превращает его в структуру: задачи, выделения и теги, которые раскладываются сами.",
    "magicLearnMore": "Изучите основы Markdown",
    "replay": "Повторить",
    "demoTitle": "Лето у моря",
    "demoBody": "Спланировать **неспешную неделю** в маленьком городке.",
    "demoTask": "Забронировать домик",
    "demoHighlight": "Поплавать ==до== завтрака",
    "demoTags": "#лето #планы",
    "intentTitle": "Что вы сюда принесёте?",
    "intentSubtitle": "Выберите несколько. Ваша первая заметка и теги уже будут ждать вас.",
    "themeTitle": "Выберите свой свет",
    "themeSubtitle": "Темы под настроение вашего письма.",
    "proTitle": "Начните со всего сразу",
    "proSubtitle": "Начните со всего с первого дня. Попробуйте бесплатно и оставьте, только если он заслужит своё место.",
    "proTrust": "Без рекламы. Без уловок. Отмена в любой момент.",
    "tryProFree": "Попробовать Pro бесплатно",
    "continueFree": "Продолжить с бесплатным планом",
    "allSetTitle": "Всё готово",
    "allSetSubtitle": "Добро пожаловать в Caliu. Настройте под себя.",
    "startWriting": "Начать писать",
    "firstNoteTitle": "Здесь всё начинается",
    "firstNoteBody": "Это моя первая заметка. Она хранится на этом устройстве, работает офлайн и следует за мной повсюду.",
    "firstNoteTask": "Записать одну мысль, которую стоит сохранить",
    "next": "Далее",
    "skip": "Пропустить",
    "back": "Назад",
    "intents": {
      "journal": "Дневник",
      "ideas": "Идеи",
      "work": "Работа",
      "study": "Учёба",
      "reading": "Чтение",
      "plans": "Планы"
    },
    "signInCta": "Вход или регистрация",
    "continueWithoutAccount": "Продолжить без аккаунта",
    "backupTitle": "Где живут ваши заметки",
    "backupSubtitle": "Заметки начинаются на этом устройстве. С аккаунтом они синхронизируются, и безопасная копия попадает на все ваши устройства.",
    "syncOffTitle": "Синхронизация выключена",
    "syncOffBody": "Войдите, чтобы синхронизировать заметки на всех устройствах.",
    "backupSignedIn": "Пока вы пишете, заметки надёжно синхронизируются.",
    "backupStageDevice": "Это устройство",
    "backupStageSafe": "Синхронизировано",
    "backupStageEverywhere": "Все ваши устройства",
    "freeNotes": "{{limit}} бесплатных заметок, без аккаунта, навсегда. Pro снимает ограничение."
  },
  "backup": {
    "evictionNotice": "Пока заметки живут только в этом браузере. При нехватке места браузер может удалить данные сайта.",
    "dismiss": "Закрыть",
    "signIn": "Войти"
  },
  "gate": {
    "share": "Войдите, чтобы делиться заметками.",
    "history": "Войдите, чтобы сохранять историю версий.",
    "import": "Войдите, чтобы импортировать заметки."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "Исходник LaTeX"
  },
  "noteLimit": {
    "banner": "{{count}} из {{limit}} заметок",
    "paywallTitle": "Вы достигли {{limit}} бесплатных заметок",
    "paywallBody": "Редактирование, поиск и синхронизация продолжают работать. Переместите заметку в корзину, чтобы освободить место, или снимите ограничение с Caliu Pro: помесячно, ежегодно или разовой покупкой навсегда.",
    "importCapped": "Импортировано только {{count}} из {{total}} файлов: бесплатный план допускает {{limit}} заметок."
  },
  "appUpdate": {
    "available": "Доступна новая версия Caliu."
  },
  "settings": {
    "title": "Настройки",
    "account": "Аккаунт",
    "writing": "Письмо",
    "keyboardShortcuts": "Сочетания клавиш",
    "editor": "Редактор",
    "yourNotes": "Ваши заметки",
    "about": "О приложении",
    "noAccount": "Нет аккаунта",
    "sendFeedback": "Отправить отзыв",
    "signInOrCreate": "Вход или регистрация",
    "notesComeWithYou": "Заметки с этого устройства останутся с вами.",
    "notSyncing": "Не синхронизируется",
    "signInToSync": "Войдите, чтобы синхронизировать заметки.",
    "sync": "Синхронизация",
    "security": "Безопасность",
    "communications": "Рассылки",
    "newsletter": "Рассылка Caliu",
    "newsletterFooter": "Короткое письмо время от времени о новых версиях и о том, что скоро появится в Caliu.",
    "newsletterError": "Не удалось обновить подписку на рассылку. Попробуйте ещё раз.",
    "appearance": "Оформление",
    "themes": "Темы",
    "sizing": "Размер",
    "systemDefault": "Системное значение",
    "separateThemes": "Разные темы для светлого и тёмного",
    "maxWidth": "Макс. ширина",
    "maxWidthHint": "Центрирует текст в удобной для чтения колонке на широких экранах",
    "markdownReturn": "Return в стиле Markdown",
    "markdownReturnHint": "Return переносит строку. Нажмите Return дважды, чтобы начать новый абзац",
    "newNoteStart": "Начало новых заметок",
    "newNoteStartH1": "Заголовок 1",
    "newNoteStartH2": "Заголовок 2",
    "newNoteStartH3": "Заголовок 3",
    "newNoteStartH4": "Заголовок 4",
    "newNoteStartDate": "Дата",
    "newNoteStartDateIso": "Дата (ISO 8601)",
    "newNoteStartDateTime": "Дата и время",
    "newNoteStartDateTimeIso": "Дата и время (ISO 8601)",
    "newNoteStartEmpty": "Пусто",
    "newNoteStartHint": "Относится к заметкам, созданным в приложении.",
    "collapsibleSections": "Сворачиваемые разделы",
    "collapsibleSectionsHint": "Позволяет свернуть заголовок и его содержимое за стрелкой",
    "experimental": "Экспериментально",
    "general": "Основные"
  },
  "toolbar": {
    "toggleSidebar": "Показать/скрыть боковое меню",
    "toggleInspector": "Показать или скрыть инспектор",
    "searchNotes": "Поиск по заметкам",
    "newNote": "Новая заметка",
    "findInNote": "Поиск в заметке",
    "showToolbar": "Показать панель инструментов",
    "hideToolbar": "Скрыть панель инструментов",
    "moreNoteActions": "Больше действий с заметкой",
    "undo": "Отменить",
    "redo": "Повторить",
    "zenMode": "Режим дзен",
    "sourceMode": "Режим исходного кода",
    "richEditor": "Форматированный редактор",
    "sortBy": "Сортировать по",
    "bold": "Полужирный",
    "italic": "Курсив",
    "heading": "Заголовок",
    "list": "Список",
    "link": "Ссылка",
    "insert": "Вставить",
    "more": "Ещё",
    "strikethrough": "Зачёркнутый",
    "table": "Таблица",
    "horizontalRule": "Горизонтальная линия",
    "codeBlock": "Блок кода",
    "inlineCode": "Встроенный код",
    "blockQuote": "Цитата",
    "math": "Формула",
    "highlight": "Выделение",
    "bulletList": "Маркированный список",
    "orderedList": "Нумерованный список",
    "photoLibrary": "Фото",
    "camera": "Камера",
    "files": "Файлы",
    "yellow": "Жёлтый",
    "green": "Зелёный",
    "blue": "Синий",
    "pink": "Розовый",
    "purple": "Фиолетовый",
    "heading1": "Заголовок 1",
    "heading2": "Заголовок 2",
    "heading3": "Заголовок 3",
    "heading4": "Заголовок 4",
    "heading5": "Заголовок 5",
    "heading6": "Заголовок 6",
    "removeHighlight": "Убрать выделение"
  },
  "whatsNew": {
    "title": "Что нового",
    "tagIconsTitle": "Значки, нарисованные для Caliu",
    "tagIconsBody": "Все значки в приложении новые и созданы специально для Caliu. Задайте каждому тегу свой значок и ищите их на своём языке.",
    "newNoteStartTitle": "Начинайте заметки по-своему",
    "newNoteStartBody": "Новая заметка может начинаться с заголовка, сегодняшней даты, даты и времени или с пустой страницы. Выберите это в Настройках, в разделе «Редактор».",
    "typographyTitle": "Текст с точностью до пункта",
    "typographyBody": "Задайте точный размер текста, межстрочный интервал и интервал между абзацами для своих заметок в Настройках, в разделе «Типографика».",
    "typographySample": "Каждая заметка следует заданному размеру, межстрочному интервалу и отступам с точностью до пункта.",
    "sampleMorningPages": "Утренние страницы",
    "newsletterTitle": "Встречайте рассылку Caliu",
    "newsletterBody": "Теперь после каждого выпуска мы присылаем короткое письмо о новинках на вашем языке. Включите рассылку, если хотите. Изменить это можно в любой момент в Настройках."
  },
  "sharing": {
    "inviteByEmail": "Пригласить по эл. почте",
    "invite": "Пригласить",
    "roleOwner": "Владелец",
    "roleEditor": "Может редактировать",
    "roleViewer": "Может просматривать",
    "generalAccess": "Общий доступ",
    "shareWithLink": "Поделиться по ссылке",
    "accessRestricted": "Только приглашённые",
    "accessView": "Все, у кого есть ссылка, могут просматривать",
    "accessEdit": "Все, у кого есть ссылка, могут редактировать",
    "remove": "Удалить",
    "leave": "Выйти",
    "leaveNote": "Выйти из заметки",
    "leaveConfirmTitle": "Выйти из этой заметки?",
    "leaveConfirmBody": "Она исчезнет из ваших списков на всех устройствах. Владелец сможет пригласить вас снова.",
    "leaveSelectedTitle": "Выйти из общих заметок?",
    "leaveSelectedBody_one": "Вы выйдете из {{count}} заметки, которой с вами поделились. Ваши собственные заметки попадут в корзину.",
    "leaveSelectedBody_few": "Вы выйдете из {{count}} заметок, которыми с вами поделились. Ваши собственные заметки попадут в корзину.",
    "leaveSelectedBody_many": "Вы выйдете из {{count}} заметок, которыми с вами поделились. Ваши собственные заметки попадут в корзину.",
    "leaveSelectedBody_other": "Вы выйдете из {{count}} заметок, которыми с вами поделились. Ваши собственные заметки попадут в корзину.",
    "sharedBy": "Владелец: {{name}}",
    "sharedList": "Общие",
    "viewOnly": "Только просмотр",
    "accessNowEditor": "Теперь вы можете редактировать эту заметку.",
    "accessNowViewer": "Теперь вы можете только просматривать эту заметку.",
    "accessRemoved": "У вас больше нет доступа к этой заметке.",
    "unsentSavedAsCopy": "Неотправленные изменения сохранены в копии.",
    "privateNote": "Закрытая заметка",
    "memberLimit": "Заметкой можно поделиться максимум с 50 людьми.",
    "rateLimit": "Слишком много приглашений. Повторите попытку позже.",
    "inviteFailed": "Не удалось отправить приглашения. Повторите попытку.",
    "invalidEmail": "Введите действительный адрес эл. почты.",
    "onlineOnly": "Подключитесь к интернету, чтобы управлять доступом.",
    "you": "Вы",
    "ownerOnly": "Только владелец может менять доступ.",
    "unavailable": "Совместный доступ сейчас недоступен. Повторите попытку позже.",
    "updateFailed": "Не удалось изменить доступ. Повторите попытку.",
    "inviteInvalid": "Это приглашение больше не действует.",
    "copyLink": "Копировать ссылку",
    "invited": "Приглашён",
    "copied": "Скопировано",
    "accessRestrictedHint": "Открыть её могут только приглашённые вами люди.",
    "onlyYouHint": "Открыть её можете только вы.",
    "accessViewHint": "Любой, у кого есть ссылка, может её читать, без аккаунта.",
    "accessEditHint": "Любой, у кого есть ссылка, может её редактировать.",
    "roleBelowLink": "Любой, у кого есть ссылка, может редактировать, поэтому приглашённые вами люди тоже могут редактировать.",
    "inviteAs": "Пригласить как",
    "revokeInvite": "Отозвать приглашение",
    "statusPeople_one": "{{count}} человек",
    "statusPeople_few": "{{count}} человека",
    "statusPeople_many": "{{count}} человек",
    "statusPeople_other": "{{count}} человека",
    "publicLink": "Публичная ссылка",
    "statusFrom": "От {{name}}",
    "removeConfirmTitle": "Удалить {{name}}?",
    "removeConfirmBody": "Этот человек больше не сможет открыть эту заметку.",
    "revokeConfirmTitle": "Отозвать приглашение для {{name}}?",
    "revokeConfirmBody": "Ссылка из приглашения перестанет работать.",
    "peopleWithAccess": "Участники с доступом",
    "addPeoplePlaceholder": "Добавить участников по эл. почте",
    "invitePro": "Приглашение участников входит в Caliu Pro.",
    "inviteKeepsAccess": "Приглашённые сохранят доступ, даже если вы отключите ссылку.",
    "youSuffix": "(вы)"
  },
  "noAccess": {
    "title": "У вас нет доступа к этой заметке",
    "linkBody": "Владелец не поделился ею с вами. Попросите его пригласить вас или включить ссылку.",
    "signedOutBody": "Войдите в аккаунт, с которым ею поделились.",
    "inviteTitle": "Это приглашение больше не действует",
    "inviteBody": "Попросите пригласившего вас человека отправить новое.",
    "removedTitle": "У вас больше нет доступа к этой заметке",
    "removedBody": "Владелец удалил вас.",
    "removedCopyBody": "Владелец удалил вас. Ваши неотправленные изменения сохранены как копия в ваших заметках.",
    "backToNotes": "Вернуться к заметкам",
    "signIn": "Войти"
  }
}
